import React from 'react';
import { Analytics } from '@vercel/analytics/react'; // Подключаем аналитику Vercel
import HeroSection from './components/HeroSection';
import CalculatorSection from './components/CalculatorSection';
import HowItWorksSection from './components/HowItWorksSection';
import WhyORBTXSection from './components/WhyORBTXSection';
import UseCasesSection from './components/UseCasesSection';
import RoadmapSection from './components/RoadmapSection';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <HeroSection />
      <CalculatorSection />
      <HowItWorksSection />
      <WhyORBTXSection />
      <UseCasesSection />
      <RoadmapSection />
      <Footer />
      
      {/* Этот компонент автоматически начнет собирать трэкшн 
          после деплоя на Vercel. 
      */}
      <Analytics />
    </div>
  );
}

export default App;